import { useState, useCallback } from 'react';
import SearchMedicService from '../../API/Services/SearchMedicService';
import type { MatchingUser, PaginatedMatchingUser } from '../../Types/schema-helpers';

const searchService = new SearchMedicService();

export const useMedicSearch = () => {
  const [results, setResults] = useState<MatchingUser[]>([]);
  const [total, setTotal] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(false);
  const [selectedMedic, setSelectedMedic] = useState<MatchingUser | null>(null);

  const executeSearch = useCallback(async (filters: Record<string, any> = {}) => {
    setLoading(true);
    try {
      const response: PaginatedMatchingUser = await searchService.searchMedic(filters);
      const data = response?.data || [];
      
      setResults(data);
      setTotal(response?.total || 0);
      
      // Fixed: Guarantee null instead of undefined
      setSelectedMedic(data.length > 0 ? (data[0] ?? null) : null);
    } catch (error) {
      console.error("Error executing medic search:", error);
      setResults([]);
      setTotal(0);
      setSelectedMedic(null);
    } finally {
      setLoading(false);
    }
  }, []);

  return { 
    results, 
    total, 
    loading, 
    selectedMedic, 
    setSelectedMedic, 
    executeSearch 
  };
};
